var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.313 41.1621H84.6857C86.516 41.1621 87.9997 42.6458 87.9997 44.4761V62.122C87.9997 68.8486 82.5467 74.3016 75.82 74.3016H75.7625C69.0358 74.3026 63.582 68.8504 63.5811 62.1237C63.5811 62.1231 63.5811 62.1226 63.5811 62.122V42.8941C63.5811 41.9375 64.3565 41.1621 65.313 41.1621Z",
    fill: "#5059C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4062 37.6742C82.741 37.6742 86.255 34.1602 86.255 29.8254C86.255 25.4906 82.741 21.9766 78.4062 21.9766C74.0714 21.9766 70.5574 25.4906 70.5574 29.8254C70.5574 34.1602 74.0714 37.6742 78.4062 37.6742Z",
    fill: "#5059C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9875 37.6744C60.2489 37.6744 65.3247 32.5986 65.3247 26.3372C65.3247 20.0758 60.2489 15 53.9875 15C47.7261 15 42.6503 20.0758 42.6503 26.3372C42.6503 32.5986 47.7261 37.6744 53.9875 37.6744Z",
    fill: "#7B83EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1057 41.1621H37.1278C35.3194 41.2069 33.8888 42.7077 33.9307 44.5162V64.6424C33.6782 75.4951 42.2644 84.5012 53.1168 84.7668C63.9692 84.5012 72.5554 75.4951 72.3028 64.6424V44.5162C72.3447 42.7077 70.9142 41.2069 69.1057 41.1621Z",
    fill: "#7B83EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M54.8601 41.1621V69.3656C54.8514 70.6589 54.0677 71.8208 52.8718 72.3133C52.491 72.4743 52.0817 72.5574 51.6683 72.5575H35.4648C35.238 71.9819 35.0287 71.4063 34.8543 70.8133C34.2437 68.8119 33.9322 66.7313 33.9299 64.6389V44.5109C33.8879 42.7053 35.3162 41.2069 37.1217 41.1621H54.8601Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M53.1159 41.1621V71.1098C53.1159 71.5232 53.0328 71.9325 52.8717 72.3133C52.3793 73.5092 51.2174 74.293 49.9241 74.3016H36.2845C35.988 73.7261 35.709 73.1505 35.4648 72.5575C35.2206 71.9644 35.0287 71.4063 34.8543 70.8133C34.2437 68.8119 33.9322 66.7313 33.9299 64.6389V44.5109C33.8879 42.7053 35.3162 41.2069 37.1217 41.1621H53.1159Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M53.1159 41.1621V67.6214C53.1026 69.3787 51.6814 70.8 49.9241 70.8133H34.8543C34.2437 68.8119 33.9322 66.7313 33.9299 64.6389V44.5109C33.8879 42.7053 35.3162 41.2069 37.1217 41.1621H53.1159Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M51.3717 41.1621V67.6214C51.3584 69.3787 49.9371 70.8 48.1798 70.8133H34.8543C34.2437 68.8119 33.9322 66.7313 33.9299 64.6389V44.5109C33.8879 42.7053 35.3162 41.2069 37.1217 41.1621H51.3717Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M54.8606 32.145V37.6391C54.5641 37.6566 54.285 37.674 53.9885 37.674C53.692 37.674 53.4129 37.6566 53.1164 37.6391C52.5276 37.6001 51.9437 37.5067 51.3722 37.3601C47.8402 36.5236 44.9222 34.0466 43.5234 30.6973C43.2827 30.1348 43.0958 29.5508 42.9652 28.9531H51.6687C53.4287 28.9598 54.8539 30.3849 54.8606 32.145Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M53.1167 33.8891V37.6391C52.528 37.6 51.9441 37.5066 51.3725 37.36C47.8405 36.5236 44.9225 34.0466 43.5237 30.6973H49.9248C51.6849 30.7039 53.11 32.1291 53.1167 33.8891Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M53.1167 33.8891V37.6391C52.528 37.6 51.9441 37.5066 51.3725 37.36C47.8405 36.5236 44.9225 34.0466 43.5237 30.6973H49.9248C51.6849 30.7039 53.11 32.1291 53.1167 33.8891Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M51.3725 33.8891V37.36C47.8405 36.5236 44.9225 34.0466 43.5237 30.6973H48.1807C49.9407 30.704 51.3658 32.1291 51.3725 33.8891Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1971 30.6973H48.175C49.9407 30.6973 51.3721 32.1287 51.3721 33.8943V65.8722C51.3721 67.638 49.9407 69.0693 48.175 69.0693H16.1971C14.4314 69.0693 13 67.6379 13 65.8722V33.8943C13 32.1287 14.4314 30.6973 16.1971 30.6973Z",
    fill: "url(#paint0_linear_207_32181)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6 42.8689H34.2075V60.2759H30.1349V42.8689H23.7721V39.4922H40.6V42.8689Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_207_32181",
    x1: 19.666,
    y1: 28.1991,
    x2: 44.7061,
    y2: 71.5675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A62C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4D55BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3940AB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTeams);
export default __webpack_public_path__ + "static/media/ic_teams.31fe66c2a141988dbeb578cdb500acaf.svg";
export { ForwardRef as ReactComponent };